/**
 * @generated SignedSource<<aa411a7271baff3d14a1ed7a39025387>>
 * @relayHash d593a30e4f653f30164a55fce91a2359
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf3337c639a40ae1033c0fc857af68c59671d82d06fbb681e3d43d03bc6e15bc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PopularFeedWithTimeGranularityStorageSnippetsQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  timeGranularity?: string | null | undefined;
};
export type PopularFeedWithTimeGranularityStorageSnippetsQuery$data = {
  readonly popularFeed: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly aiProperty: {
          readonly createdAt: string;
          readonly errorMessage: string | null | undefined;
          readonly objectData: string | null | undefined;
        } | null | undefined;
        readonly contentProperties: {
          readonly latest: {
            readonly generatedBy: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly excerpt: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
          readonly createdDate: string | null | undefined;
          readonly ownedBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly name: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly metadata: {
          readonly comments: {
            readonly commentsCount: number | null | undefined;
          } | null | undefined;
          readonly currentuser: {
            readonly favourited: {
              readonly isFavourite: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly lastModifiedDate: string | null | undefined;
        };
        readonly space: {
          readonly alias: string | null | undefined;
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
        readonly version: {
          readonly friendlyWhen: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    }>;
    readonly pageInfo: {
      readonly endCursor: string;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
};
export type PopularFeedWithTimeGranularityStorageSnippetsQuery = {
  response: PopularFeedWithTimeGranularityStorageSnippetsQuery$data;
  variables: PopularFeedWithTimeGranularityStorageSnippetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": "default",
  "kind": "LocalArgument",
  "name": "timeGranularity"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "timeGranularity",
    "variableName": "timeGranularity"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "subType"
},
v8 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v9 = {
  "args": [
    {
      "kind": "Literal",
      "name": "entryPoint",
      "value": "CONFLUENCE_HOME_POPULAR_FEED"
    }
  ],
  "concreteType": "ConfluenceContentAISummaryResponse",
  "kind": "LinkedField",
  "name": "aiProperty",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "errorMessage"
    },
    {
      "kind": "ScalarField",
      "name": "createdAt"
    },
    {
      "kind": "ScalarField",
      "name": "objectData"
    }
  ],
  "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")"
},
v10 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v11 = {
  "args": [
    {
      "kind": "Literal",
      "name": "length",
      "value": 350
    }
  ],
  "kind": "ScalarField",
  "name": "excerpt",
  "storageKey": "excerpt(length:350)"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v14 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v12/*: any*/)
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v16 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v17 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v18 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v19 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "KnownUser"
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "UnknownUser"
},
v21 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "commentsCount"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    }
  ]
},
v22 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "friendlyWhen"
    }
  ]
},
v23 = {
  "concreteType": "FeedPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedPopularFeed",
        "kind": "LinkedField",
        "name": "popularFeed",
        "plural": false,
        "selections": [
          {
            "concreteType": "PopularFeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v21/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          },
          (v23/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedPopularFeed",
        "kind": "LinkedField",
        "name": "popularFeed",
        "plural": false,
        "selections": [
          {
            "concreteType": "PopularFeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v21/*: any*/),
                  (v22/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v23/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d593a30e4f653f30164a55fce91a2359",
    "id": "cf3337c639a40ae1033c0fc857af68c59671d82d06fbb681e3d43d03bc6e15bc",
    "metadata": {},
    "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
    "operationKind": "query",
    "text": "query PopularFeedWithTimeGranularityStorageSnippetsQuery($first:Int,$after:String,$timeGranularity:String=\"default\"){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\"){errorMessage,createdAt,objectData},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "0fa019294b5d7309cd5a14857ea96a52";

export default node;
